import React, { useState, useEffect } from 'react'
import { Menu, MenuItem } from 'semantic-ui-react'

const NavBar = ({ activeItem, onChangeItem, isMobile, user }) => {
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setInnerWidth(window.innerWidth)
        }
        window.addEventListener('resize', handleResize)
        return () => {
            window.removeEventListener('resize', handleResize)
        }
    }, [])

    const numberWithCommas = (x) => {
        return x?.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    }

    return <Menu inverted className={isMobile ? 'mobile-menu' : ''} style={{ background: '#1b1c1d', border: '1px solid #444' }}>
            {innerWidth > 400 ? (<MenuItem className="logo-item"><img alt="logo" src="/egc-logo.png" /></MenuItem>) : null}
            <MenuItem name="games" active={activeItem === 'games'} onClick={() => onChangeItem('games')} style={{ color: 'white' }}>Games</MenuItem>
            <MenuItem name="orders" active={activeItem === 'orders'} onClick={() => onChangeItem('orders')} style={{ color: 'white' }}>Orders</MenuItem>
            <MenuItem name="account" active={activeItem === 'account'} onClick={() => onChangeItem('account')} style={{ color: 'white' }}>Account</MenuItem>
            {innerWidth > 600 ? (<h4 className="welcome-message" style={{ marginLeft: 20, marginTop: 18, color: 'white' }}>Welcome, {user ? user.name : ''}</h4>) : null}
            {user && user.balance !== null ? (
                <h4 className="balance-message" style={{ marginLeft: innerWidth > 600 ? 30 : 20, marginTop: innerWidth > 600 ? 18 : 8, color: 'white' }}>
                    Account Balance: ${numberWithCommas(user.balance?.toFixed(2))}
                </h4>
            ) : null}
        </Menu>
}

export default NavBar